import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Fields of `investmentDeductionAllowance` saved by the block project-iab-tax-data
 * ("IAB- und Steuerdaten") with their payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectIabTaxDataInput`.
 */
const PROJECT_IAB_TAX_DATA_FIELD_TYPES = {
  taxTable: 'string',
  effectiveTaxRatePercent: 'number',
  churchTaxRatePercent: 'number',
  taxRatePercent: 'number',
  taxableIncomeEur: 'number',
  iabPercent: 'number',
};

export const PROJECT_IAB_TAX_DATA_INPUT_FIELDS = Object.keys(PROJECT_IAB_TAX_DATA_FIELD_TYPES);

/**
 * `ProjectIabTaxDataInput` from the block object (or the unsaved project): the six fields of
 * `investmentDeductionAllowance`.
 */
export const toProjectIabTaxDataInput = (project) =>
  preparePayloadForGraphQL(
    project.investmentDeductionAllowance ?? {},
    PROJECT_IAB_TAX_DATA_FIELD_TYPES
  );
